import { Flex, Spinner, Text, TextContainer, TextHeading } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../messages";

export const ConnectorPropertiesLoading = ({ connectorName }: { connectorName: string }) => {
  const intl = useIntl();
  return (
    <Flex direction="column" gap="6">
      <TextContainer spacing="0">
        <TextHeading>{intl.formatMessage(MESSAGES.pleaseWait)}</TextHeading>
        <Text>{intl.formatMessage(MESSAGES.pullingAccounts, { platform: connectorName })}</Text>
      </TextContainer>
      <Spinner size={32} />
    </Flex>
  );
};
